module.exports = __webpack_public_path__ + "img/Koreans.d5fcf85b.png";